import { UserTypeEnum } from "./global/enums/UserType.enum";
import { PermissionsEnum } from "./users/enums/permissions";

export class LoginModel {
  userName!: string;
  password!: string;
}

export class User {
  LoginStatusMessage!: string
  Token!: string
  expiration!: string
  ImagePath!: string
  UserState!: string
  UserType!: UserTypeEnum
  UserID!: string
  FullName!: string
  FullNameArabic!: string
  UserRoles: string[] = [];
  SuccessLogin!: boolean
  RefreshToken!: string;
  isCpaUser!: boolean
  requiresRegistration!: boolean
  EncodedRefreshToken!: string;
  Email!: string
  FirstName!: string
  LastName!: string
  TicketId!: string
  role: any;
  TrainingPermissions: string[] = [];
}

